import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, Container, Button } from '@pella/sash-framework';
import PlantMROSubInvSelector from '../../organisms/PlantMROSubInvSelector';
import { useUserMutation } from '../../../hooks';
import styles from './Preferences.module.css';

const AnyPlantMROSubInvSelector = /** @type {import('react').ElementType} */ (PlantMROSubInvSelector);

/**
 * Preferences page component for managing user Move Order preferences.
 * @returns {import('react').ReactElement} The Preferences component
 */
const Preferences = () => {
  const { addTeamMemberAppPref } = useUserMutation();
  const navigate = useNavigate();
  const [showCOALookup, setShowCOALookup] = useState(false);
  const [selectorValue, setSelectorValue] = useState(null);

  const updatePrefOnClick = async () => {
    const updatedPref = {
      preference: {
        apps: {
          MoveOrderSubInvLoc: selectorValue.settings.MoveOrderSubInvLoc,
          MoveOrderShipToLoc: selectorValue.settings.MoveOrderShipToLoc,
          MoveOrderMROOrg: selectorValue.settings.MoveOrderMROOrg,
          MoveOrderDestinationAcct: selectorValue.settings.MoveOrderDestinationAcct || null,
        },
      },
    };

    if (selectorValue.validated) {
      try {
        await addTeamMemberAppPref.mutateAsync({
          preference: updatedPref.preference,
          prefId: 'MoveOrder',
        });
        toast.success('Preferences Updated Successfully!');
      } catch {
        // error toast handled by useUserMutation onError
      }
    } else {
      toast.error('Selected values are not valid. Please review your selections.');
    }
  };

  const selectedValueOnChange = (e) => {
    setSelectorValue(e);
  };
  const UpdateShowCOALookup = (e) => {
    setShowCOALookup(e);
  };

  return (
    <>
      <Container>
        Preferences
        <Container>
          <AnyPlantMROSubInvSelector
            selectedValueOnChange={selectedValueOnChange}
            COALLookupActive={UpdateShowCOALookup}
            showSavePreferences={false}
            defaultExpanded
          />
        </Container>
      </Container>
      <div className={styles.actionButtons}>
        {!showCOALookup ? (
          <div className={styles.buttonGroup}>
            <Button color='secondary' size='sm' onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button disabled={!selectorValue?.validated} color='primary' size='sm' onClick={updatePrefOnClick}>
              Update Preferences
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Preferences;
